/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { MessageContent$inboundSchema, MessageContent$outboundSchema, } from "./messagecontent.js";
/** @internal */
export const StreamingConversationMessage$inboundSchema = z.object({
    data: z.string().transform((v, ctx) => {
        try {
            return JSON.parse(v);
        }
        catch (err) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `malformed json: ${err}`,
            });
            return z.NEVER;
        }
    }).pipe(MessageContent$inboundSchema),
});
/** @internal */
export const StreamingConversationMessage$outboundSchema = z.object({
    data: MessageContent$outboundSchema,
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var StreamingConversationMessage$;
(function (StreamingConversationMessage$) {
    /** @deprecated use `StreamingConversationMessage$inboundSchema` instead. */
    StreamingConversationMessage$.inboundSchema = StreamingConversationMessage$inboundSchema;
    /** @deprecated use `StreamingConversationMessage$outboundSchema` instead. */
    StreamingConversationMessage$.outboundSchema = StreamingConversationMessage$outboundSchema;
})(StreamingConversationMessage$ || (StreamingConversationMessage$ = {}));
export function streamingConversationMessageToJSON(streamingConversationMessage) {
    return JSON.stringify(StreamingConversationMessage$outboundSchema.parse(streamingConversationMessage));
}
export function streamingConversationMessageFromJSON(jsonString) {
    return safeParse(jsonString, (x) => StreamingConversationMessage$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'StreamingConversationMessage' from JSON`);
}
//# sourceMappingURL=streamingconversationmessage.js.map